// extracted by mini-css-extract-plugin
export default {"content":"Movies_content__wXaAw","fadeIn":"Movies_fadeIn__9XfRL","title":"Movies_title__MDLXB","loader":"Movies_loader__HrPf0"};